import { useEffect, useRef, useState } from "react";
import { initGame, initThreeMode, mode2List, mode3List, sounds } from "../../utils/constants";
import { getWidth, openRewardedVideo, playSound, showAdvAfterRound } from "../../utils/helpers";
import RoundInfo from "../../components/RoundInfo";
import Game from "../../components/Game";
import RewardPopup from "../../components/RewardPopup";

function GameContainer() {
	const [openReward, setOpenReward] = useState(false);
	const [stepCount, setStepCount] = useState(0);
	const [youIsWin, setYouIsWin] = useState(false);
	const [isPlayed, setIsPlayed] = useState(false);
	const [openIds, setOpenIds] = useState({});
	const [imagesList, setImagesList] = useState([]);
	const [isLocked, setIsLocked] = useState(initThreeMode());
	const [width, setWidth] = useState(0);
	const [state, setState] = useState({
		count: "2",
		mode: "6",
	});
	const { count, mode } = state;
	const winInfo = useRef({
		time: "",
		steps: 0,
	});
	const gameRef = useRef();

	useEffect(() => {
		const child = document.getElementById("game_wrapper");
		if (!child) return;

		const resizeWindow = () => {
			setWidth(getWidth(imagesList, gameRef, child));
		};

		resizeWindow();
		window.addEventListener("resize", resizeWindow);

		return () => {
			window.removeEventListener("resize", resizeWindow);
		};
	}, [imagesList.length, gameRef]);

	useEffect(() => {
		if (Object.values(openIds).flat().length === +mode) {
			setTimeout(() => {
				if (sounds.backgroundPlay.playing()) {
					sounds.youWinPlay.play();
				}
				setYouIsWin(true);
				setIsPlayed(false);
			}, 500);
		}
	}, [mode, openIds]);

	useEffect(() => {
		setImagesList(initGame(mode, count));
		setOpenIds({});
	}, [state]);

	const showReward = () => {
		openRewardedVideo({
			openCallback: () => {
				setOpenReward(false);
			},
			onRewarded: () => {
				setIsLocked(true);
				onChangeCount("3", true);
				window.localStorage.setItem("threeMode", Date.now());
			},
		});
	};

	const onChangeMode = (val) => {
		if (isPlayed || val === state.mode) return;
		restartGame();
		setState((prev) => ({
			...prev,
			mode: val,
		}));
	};

	const onChangeCount = (val, isVideoMode) => {
		if (isPlayed || val === state.count) return;

		if (val === "3" && !isLocked && !isVideoMode) {
			setOpenReward(true);
			return;
		}

		restartGame();
		const list = val === "2" ? mode2List : mode3List;
		setState({
			count: val,
			mode: list.find((item) => item.value === mode) ? mode : list[0].value,
		});
	};

	const restartGame = () => {
		playSound();
		setImagesList(initGame(state.mode, state.count));
		setOpenIds({});
		setIsPlayed(false);
		setStepCount(0);
		setYouIsWin(false);
		if (window.sdk?.features) {
			window.sdk.features.GameplayAPI.stop();
		}
	};

	const onClickImage = (typeId, id) => {
		if (!isPlayed) return;
		let halfSelectedCount = 0;

		playSound();
		setOpenIds((prev) => {
			Object.values(prev).forEach((item) => {
				if (item.length < +count) {
					halfSelectedCount += item.length;
				}
			});
			if (prev[typeId]?.length === (count === "2" ? 1 : 2) && halfSelectedCount === (count === "2" ? 1 : 2)) {
				if (sounds.backgroundPlay.playing()) {
					sounds.smallWin.play();
				}
			}

			setStepCount((prev) => ++prev);

			if (halfSelectedCount === +count) {
				const currentType = { [typeId]: [id] };

				for (const element in prev) {
					if (prev[element].length === +count) {
						currentType[element] = prev[element];
					}
				}
				return currentType;
			}

			return { ...prev, [typeId]: [...(prev[typeId] || []), id] };
		});
	};

	const openAll = () => {
		const allOpen = {};
		imagesList.forEach((item) => {
			item.forEach((elem) => {
				allOpen[elem.typeId] = [...(allOpen[elem.typeId] || []), elem.id];
			});
		});
		setOpenIds(allOpen);
	};

	const playGame = () => {
		showAdvAfterRound().then(() => {
			setYouIsWin(false);
			setImagesList(initGame(state.mode, state.count));
			setOpenIds({});
			setStepCount(0);
			setIsPlayed(true);
			playSound();
			if (window.sdk?.features) {
				window.sdk.features.GameplayAPI.start();
			}
		});
	};

	return (
		<div className="app">
			<div className="controlPanel">
				<RoundInfo
					onChangeCount={onChangeCount}
					onChangeMode={onChangeMode}
					stepCount={Math.floor(stepCount / +count)}
					isPlayed={isPlayed}
					count={count}
					winInfo={winInfo}
					closeGame={restartGame}
					mode={mode}
					isLocked={isLocked}
					openAll={openAll}
					youIsWin={youIsWin}
					setYouIsWin={setYouIsWin}
				/>
			</div>

			<div className="game" ref={gameRef}>
				<Game
					imagesList={imagesList}
					onClickImage={onClickImage}
					openIds={openIds}
					youIsWin={youIsWin}
					winInfo={winInfo}
					isPlayed={isPlayed}
					mode={mode}
					playGame={playGame}
					width={width}
				/>
			</div>

			{openReward && (
				<RewardPopup type={"openMode"} onClose={() => setOpenReward(false)} showReward={showReward} />
			)}
		</div>
	);
}

export default GameContainer;
